import { getPath } from "../../utils";

const initialState = {
  trainingStatusList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_TRAINING_STATUS_LIST":
      return setTrainingStatusList(state, action);
    case "RESET_TRAINING_STATUS":
      return resetTrainingStatus(state, action);
    default:
      return state;
  }
}

const setTrainingStatusList = (state, action) => {
  return {
    ...state,
    trainingStatusList: getPath(action.payload, "courses", []),
  };
};

const resetTrainingStatus = (state, action) => {
  return {
    ...state,
    trainingStatusList: [],
  };
};
